import { FC } from 'react';

import { TestMetadata } from '../../types';
import { useResponsiveNavBar } from '../NavBarContext';

import './NavBarMenuLineSeparator.scss';

export interface NavBarMenuLineSeparatorProps {
  testMetadata?: TestMetadata;
}

const NavBarMenuLineSeparator: FC<NavBarMenuLineSeparatorProps> = ({
  testMetadata,
}) => {
  const { getBreakpointClassName } = useResponsiveNavBar();

  return (
    <hr
      className={getBreakpointClassName('sb-navbar-menu-line-separator')}
      {...testMetadata}
    />
  );
};

export default NavBarMenuLineSeparator;
